var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('main',[_c('div',{staticClass:"title"},[_c('h1',[_vm._v("Page not found.")]),_c('br'),_c('h2',[_vm._v("404")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }